export class ArrayUtilities {
  /** Returns the input string formatted as Title Case. */
  public static enumToArray(enumeration: object): object {
    return Object.keys(enumeration).map((key) => ({
      value: enumeration[key],
      title: key,
    }));
  }
  public static enumToStringArray(enumeration: object): Array<string> {
    return Object.keys(enumeration).map((key) => enumeration[key]);
  }

  public static mapUnderscoreId(item: any): void {
    if (item['_id']) {
      item['id'] = item['_id'];
    }
  }

  public static sort(
    array: Array<any>,
    property: string = undefined,
    order: SortOrder = SortOrder.asc
  ): Array<any> {
    if (order === SortOrder.asc) {
      if (array.find((x) => typeof x[property] !== 'number'))
        return [
          ...new Set(
            array.sort(
              (a, b) =>
                a[property].localeCompare(b[property]) ||
                b[property] - a[property]
            )
          ),
        ];
      else array.sort((a, b) => a[property] - b[property]);
    } else {
      const sortedArray = array.sort((a, b) =>
        a[property] < b[property] ? 1 : -1
      );
      return [...new Set(sortedArray)];
    }
  }
}

export enum SortOrder {
  asc = 'ascending',
  desc = 'descending',
}
